import { TimePeriod } from "../../hooks/useDetectTimePeriod";
import { SelectOptionType } from "../../types/types";
import { Time } from "./InvoiceTime";

type CreateDefaultTimeFilterParams = {
  orgId: string;
  presetFilters?: Partial<Time>;
};

export const createDefaultTimeFilter = ({
  orgId,
  presetFilters,
}: CreateDefaultTimeFilterParams): Time => ({
  filterByDate: [TimePeriod.LastYear],
  filterByWorkType: [],
  filterByClient: [],
  filterByAssignee: [],
  filterByStatus: null,
  fromDate: null,
  toDate: null,
  orgId,
  sortOrder: "desc",
  sortBy: "Date",
  ...presetFilters,
});

export const createPresetClientFilter = (
  clientId: string,
  label = "Current Contact",
): SelectOptionType => ({
  value: clientId,
  label,
});

/**
 * The filter-time request a Time tab (work item or client) sends when it
 * opens: default filter (last 12 months), first page. Used for the tab's
 * count so the number matches the rows the tab shows by default.
 */
export const defaultTabTimeQueryArgs = ({
  orgId,
  customerId,
  workId,
}: {
  orgId: string;
  customerId?: string;
  workId?: string;
}) => {
  const filter = createDefaultTimeFilter({ orgId });
  return {
    filterByClient: customerId ? [customerId] : [],
    filterByAssignee: [],
    filterByWorkType: [],
    filterByStatus: filter.filterByStatus,
    filterByBillable: null,
    filterByDate: filter.filterByDate,
    fromDate: undefined,
    toDate: undefined,
    orgId,
    sortOrder: filter.sortOrder,
    sortBy: filter.sortBy,
    filterByWork: workId ? [workId] : [],
    filterByWorkTask: [],
    pageNumber: 1,
    pageSize: 20,
  };
};
